import JsBridge from "~/utils/webview";

export default defineNuxtPlugin({
  name: "js-bridge-plugin",
  parallel: true,
  setup(nuxtApp) {
    window.JsBridge = JsBridge;
    nuxtApp.provide("JsBridge", JsBridge);
  },
});

declare module "nuxt/app" {
  interface NuxtApp {
    $JsBridge: typeof JsBridge;
  }
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $JsBridge: typeof JsBridge;
  }
}
